module.exports = __webpack_public_path__ + "img/grey-podcasts-4.058f737f.png";